import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Content, SubContent, Main } from "../../../components/Layout";
import { Row, Col } from "react-bootstrap";
import styleButton from "../../../components/Button/Button.module.css";
import Loading from "../../../components/Loading";
import StatusFlag from "../../../components/StatusFlag";
import Slct from "../../../components/Slct";
import TableResponsive from "../../../components/TableResponsive";
import { formatPhone } from "../../../util/functions";
import Sign from "../../../components/Sign";
import { PrintPage } from "../../../components/PrintPage";
import useWrapper from "../../../hooks/useWrapper";
import { useOutletContext } from "react-router-dom";
import IcMail2 from "../../../components/Svg/IcMail2";
import Tooltip2 from "../../../components/Tooltip";
import { toast } from "react-toastify";
import { formatTrainee } from "../../../hooks/api/listTrainees";
import MeusDadosIco from "../../../components/Svg/new/meus-dados";

export default function Graduate() {
  const { commercial, reload, setreload } = useOutletContext();
  const { setbreadcrumb, me } = useWrapper();

  const [trainees, settrainees] = useState();
  useEffect(() => {
    if (commercial) {
      let _trainees = commercial?.trainees?.map(__trainee => formatTrainee(__trainee));
      _trainees.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      settrainees(_trainees);
    }
  }, [commercial]);

  const navigate = useNavigate();
  const permissions = JSON.parse(me.permissions);

  const { commercialId } = useParams();

  function redirectCreate() {
    permissions.trainee.create && navigate(`/trainees/new/${commercialId}`);
  }

  const [printRelations, setprintRelations] = useState([]);

  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial]);

  return (
    <PrintPage has_logo={true}>
      <Main>
        {commercial ? (
          <Content noBG="true">
            <Row className="mb-4">
              <Col>
                <SubContent>
                  <div className="d-flex justify-content-between mb-4 -hide-on-print">
                    <h2 className="form-title">Formandos</h2>
                    <div>
                      {permissions.trainee.create && (
                        <button onClick={() => redirectCreate()} className={`${styleButton.button_ghost} ml-2`}>
                          <span>Novo Formando</span>
                        </button>
                      )}
                    </div>
                  </div>
                  <TableResponsive
                    table={{
                      head: [
                        { data: "Formando" },
                        {
                          data: (
                            <>
                              <span>Contato</span>
                              <Tooltip2 tip="Copiar Lista de E-mails">
                                <button
                                  className="simple-ico ml-2"
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      trainees.reduce((__email_list, __trainee) => {
                                        if (__trainee.status !== "Cancelado") {
                                          return (__email_list += `${__trainee.email}; `);
                                        } else {
                                          return __email_list;
                                        }
                                      }, "") || "",
                                    );
                                    toast.success("Lista de E-mails Copiada!");
                                  }}
                                >
                                  <IcMail2 />
                                </button>
                              </Tooltip2>
                            </>
                          ),
                          className: `${
                            printRelations.some(__relation => __relation.value === "Contatos") ? "" : "-hide-on-print"
                          }`,
                        },
                        {
                          data: "Endereço",
                          className: `soft-hide ${
                            printRelations.some(__relation => __relation.value === "Endereço")
                              ? "-cell-on-print"
                              : "-hide-on-print"
                          }`,
                        },
                        {
                          data: "Pacote",
                          className: `soft-hide ${
                            printRelations.some(__relation => __relation.value === "Pacotes")
                              ? "-cell-on-print"
                              : "-hide-on-print"
                          }`,
                        },
                        {
                          data: "Acesso",
                          className: `${
                            printRelations.some(__relation => __relation.value === "Acesso") ? "" : "-hide-on-print"
                          }`,
                        },
                        {
                          data: "Vínculo",
                          className: `${
                            printRelations.some(__relation => __relation.value === "Vínculo") ? "" : "-hide-on-print"
                          }`,
                        },
                        {
                          data: "Data",
                          className: `soft-hide ${
                            printRelations.some(__relation => __relation.value === "Data")
                              ? "-cell-on-print"
                              : "-hide-on-print"
                          }`,
                        },
                        {
                          data: "Assinatura",
                          className: `soft-hide ${
                            printRelations.some(__relation => __relation.value === "Assinatura")
                              ? "-cell-on-print"
                              : "-hide-on-print"
                          }`,
                        },
                      ],
                      body:
                        trainees?.map(__trainee => ({
                          link: `/trainees/edit/${__trainee.id}`,
                          disabled: !!__trainee.cancel,
                          ...(!!__trainee.cancel ? { className: "-hide-on-print" } : {}),
                          data: [
                            {
                              element: (
                                <>
                                  {__trainee.is_member ? (
                                    <span className="smaller-ico">
                                      <MeusDadosIco />
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                  {__trainee.name}
                                </>
                              ),
                            },
                            {
                              element: (
                                <>
                                  <span className="d-block">{__trainee.email}</span>
                                  <span className="d-block">{formatPhone(__trainee.cell)}</span>
                                </>
                              ),
                              className: `${
                                printRelations.some(__relation => __relation.value === "Contatos")
                                  ? ""
                                  : "-hide-on-print"
                              }`,
                            },
                            {
                              element: (
                                <>
                                  <span className="d-block">{__trainee.cep}</span>
                                  <span className="d-block">
                                    {__trainee.address}, {__trainee.number}
                                  </span>
                                  <span className="d-block">{__trainee.district}</span>
                                </>
                              ),
                              className: `soft-hide ${
                                printRelations.some(__relation => __relation.value === "Endereço")
                                  ? "-cell-on-print"
                                  : "-hide-on-print"
                              }`,
                            },
                            {
                              element: <span>{__trainee.packages_data?.package?.name || "-"}</span>,
                              className: `soft-hide ${
                                printRelations.some(__relation => __relation.value === "Pacotes")
                                  ? "-cell-on-print"
                                  : "-hide-on-print"
                              }`,
                            },
                            {
                              element: (
                                <>
                                  <span>
                                    <StatusFlag status={__trainee.access} />
                                  </span>
                                </>
                              ),
                              className: `${
                                printRelations.some(__relation => __relation.value === "Acesso") ? "" : "-hide-on-print"
                              }`,
                            },
                            {
                              element: (
                                <>
                                  <span>
                                    <StatusFlag status={__trainee.bond} />
                                  </span>
                                </>
                              ),
                              className: `${
                                printRelations.some(__relation => __relation.value === "Vínculo")
                                  ? ""
                                  : "-hide-on-print"
                              }`,
                            },
                            {
                              element: <Sign date={true} />,
                              className: `soft-hide ${
                                printRelations.some(__relation => __relation.value === "Data")
                                  ? "-cell-on-print"
                                  : "-hide-on-print"
                              }`,
                            },
                            {
                              element: <div style={{ width: "150px" }}></div>,
                              className: `soft-hide ${
                                printRelations.some(__relation => __relation.value === "Assinatura")
                                  ? "-cell-on-print"
                                  : "-hide-on-print"
                              }`,
                            },
                          ],
                        })) || [],
                    }}
                  />
                  <div className="mt-4 d-flex justify-content-between w-100-child -hide-on-print">
                    <Slct
                      value={printRelations}
                      options={[
                        { label: "Contatos", value: "Contatos" },
                        { label: "Acesso", value: "Acesso" },
                        { label: "Pacotes", value: "Pacotes" },
                        { label: "Endereço", value: "Endereço" },
                        { label: "Assinatura", value: "Assinatura" },
                        { label: "Data", value: "Data" },
                      ]}
                      onChange={ev => {
                        setprintRelations(ev);
                      }}
                      placeholder="Campos para impressão"
                      className="w-100 mr-2"
                      isMulti="true"
                      menuPlacement="top"
                    />
                    <PrintPage.PrintButton label="Imprimir Relação" />
                  </div>
                </SubContent>
              </Col>
            </Row>
            {/* <Paginacao/> */}
          </Content>
        ) : (
          <Content>
            <Loading />
          </Content>
        )}
      </Main>
    </PrintPage>
  );
}
